import { useCallback } from 'react';
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';

const usePagination = ({ limit = 8 } = {}) => {
  const [searchParams] = useSearchParams();
  const currentPage = Number(searchParams.get('page') ?? 1);
  const currentLimit = Number(searchParams.get('limit') ?? limit);

  const location = useLocation();
  const navigate = useNavigate();

  const updatePageUrl = useCallback(
    (pageNumber, newLimit) => {
      const params = new URLSearchParams(searchParams);
      params.set('page', pageNumber.toString());
      if (newLimit) {
        params.set('limit', newLimit.toString());
      }
      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      });
      navigate(`${location.pathname}?${params.toString()}`);
    },
    [location.pathname, navigate, searchParams]
  );

  return {
    page: currentPage,
    limit: currentLimit,
    updatePageUrl,
  };
};

export default usePagination;
